import Subscribe from './views/Subscribe.vue';

export default [
  {
    path: 'subscribe',
    component: Subscribe,
    name: '订阅管理',
  },
];
